import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Aggiunta} from "../_Models";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-listino-prodotti-aggiunte',
  templateUrl: './listino-prodotti-aggiunte.component.html'
})
export class ListinoProdottiAggiunteComponent implements OnInit {
  @Input() Aggiunte: Aggiunta[] = [];
  @Output() AggiunteChange = new EventEmitter();
  @Input() Editabile: boolean = true;
  @Input() Title: string = this.translate.instant('listino.aggiunte');
  constructor(
    private toastService: ToastrService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
  }
  add() {
    this.Aggiunte = [new Aggiunta()].concat(this.Aggiunte);
  }
  stringanonvuota(item: string){
    return item != " " && item != "" && item != null
  }
  edit(item: Aggiunta) {
    item.modifica = !item.modifica;
    item.backup = Object.assign({}, item);
    if(item.modifica ) return;
    if (this.stringanonvuota(item.nome) && !isNaN(item.prezzo)){
      this.AggiunteChange.emit(this.Aggiunte);
      return;
    }
    if (!this.stringanonvuota(item.nome))
      this.toastService.warning("inserire un nome", "Attenzione!!");
    if (isNaN(item.prezzo))
      this.toastService.warning("inserire un'unità di misura", "Attenzione!!");
    item.modifica = !item.modifica;

  }
  delete(item: Aggiunta) {
    if(item.modifica) {
      item.prezzo = item.backup.prezzo;
      item.nome = item.backup.nome;
      item.modifica = false;
    }
    else {
      const idx: number = this.Aggiunte.findIndex(x => x == item);
      if (idx > -1)
        this.Aggiunte.splice(idx, 1);
      this.AggiunteChange.emit(this.Aggiunte);
    }
  }

}
